import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Container,
  Avatar,
  CircularProgress,
  Alert
} from '@mui/material';
import { Microsoft, Security } from '@mui/icons-material';
import { useAuthContext } from '../contexts/AuthContext';
import RoleSelector from '../components/auth/RoleSelector';

const LoginPage: React.FC = () => {
  const { loginWithAzure, loading } = useAuthContext();
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    // Check if we were redirected due to session expiration
    const expired = sessionStorage.getItem('session_expired');
    if (expired) {
      setSessionExpired(true);
      // Clear the flag so it doesn't show again on refresh
      sessionStorage.removeItem('session_expired');
    }
  }, []);

  const handleLogin = async () => {
    try {
      await loginWithAzure();
    } catch (error) {
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Card sx={{ width: '100%', maxWidth: 400, textAlign: 'center' }}>
          <CardContent sx={{ p: 4 }}>
            {sessionExpired && (
              <Alert severity="info" sx={{ mb: 2, textAlign: 'left' }}>
                Your session has expired. Please sign in again to continue.
              </Alert>
            )}
            
            <Avatar
              sx={{
                mx: 'auto',
                mb: 2,
                bgcolor: 'primary.main',
                width: 56,
                height: 56,
              }}
            >
              <Security />
            </Avatar>
            
            <Typography variant="h4" gutterBottom>
              OSINT Explorer
            </Typography>
            
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontStyle: 'italic' }}>
              Endurion
            </Typography>
            
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Sign in with your Microsoft account to access the OSINT Explorer location-based intelligence analytics platform.
            </Typography>
            
            <Button
              variant="contained"
              size="large"
              fullWidth
              startIcon={loading ? <CircularProgress size={20} /> : <Microsoft />}
              onClick={handleLogin}
              disabled={loading}
              sx={{ mb: 2 }}
            >
              {loading ? 'Signing In...' : 'Sign in with Microsoft'}
            </Button>
            
            <Typography variant="caption" color="text.secondary">
              This application uses Azure AD authentication with role-based access control.
              Contact your administrator if you need access.
            </Typography>
            
            
            <RoleSelector />
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default LoginPage;